(function(){
    'use strict';
    angular.module('app').controller('CreateCommentModalController', CreateCommentModalController);
    
    CreateCommentModalController.$inject = [
        'ServiceRequestTicketService',
        '$uibModalInstance',
        'toastr',
        'ticketId'
    ];
    
    function CreateCommentModalController(
        ServiceRequestTicketService,
        $uibModalInstance,
        toastr,
        ticketId
    ) {
        const vm = this;
        vm.close = close;
        vm.create = create;
        vm.ticket={};
       

        function create(form) {
            if(!vm.ticket.commentText){
               toastr.warning('Please Add comment');
                return
            }
           
            ServiceRequestTicketService.newComment(ticketId,
                res=>{
                    toastr.success('Successfully Create');
                    $uibModalInstance.close(true);
                },
                err=>{
                    console.log(err)
                    toastr.error(err.message);
                },vm.ticket
            )
        }

        function close() {
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/service-tickets/modal/CreateCommentModalController.js